import styled, { css } from 'styled-components'
import Icon from '@mdi/react'

import Image from 'components/Image'
import theme from 'theme_'

const baseAvatar = css`
  color: ${theme.colors.darkeyGrey};
  width: 40px;
  height: 40px;
  border-radius: 20px;
  object-fit: cover;
`

export const StyledUserAvatar = styled(Image)`
  ${baseAvatar};
`

export const StyledUserDefaultAvatar = styled(Icon)`
  ${baseAvatar};
  flex-shrink: 0;
  height: 49px;
  width: 49px;
  margin-left: -5px;
`
